/* Wild Linens - brand scripts, part two (from 9 Sep 2026, Studio Rossi)
   Loaded from snippets/footer-copyright.liquid. Anything new goes here.

   1. Tidy "205 g/m²" to "205g/m²" everywhere it is shown (cards,
      product titles, quick view, bag, search). Display only.
   2. Drop the " GBP" the theme prints after prices and close up
      "£23.40 / m" to "£23.40/m".
   3. In titles, wrap the weight in <span class="wl-weight"> so the
      stylesheet can set it at the price size.
   4. Cards (13 Sep): "washed", "pure" and "fabric" are dropped from
      the name on every card, site-wide, the weight is moved out of
      the name onto its own line, and the word "From" is dropped from
      the price, so a card reads
        Moss green linen
        205g/m²
        £23.40/m  £26.00            Add
      The first letter is put back in capitals. Display only, cards
      only; the product's own name, its page, its price wording there
      and its title in search are untouched.
   5. Fabric samples button in the header: the footer newsletter's
      chevron is copied in as real markup, so the two arrows match.
   6. FAQ heading: the last word drops to a second line in italic.
   7. Product page price: the theme prints "£23.40 per metre" in a
      separate <small>; that becomes "/m" closed up to the figure, so
      the product page reads like the cards.
   8. Judge.me: the app adds its own review badge on top of the one
      placed in the product template, so the page carries two. Every
      badge after the first is hidden.
   9. Filter & sort drawer (13 Sep). One control on every collection
      page, "Filter & sort", opens the theme's panel as a drawer from
      the left. The theme builds a Sort by group inside that panel
      and, where filters are on, the filter groups beneath it; on
      pages without filters the drawer holds Sort by alone. The
      toolbar's own Sort by dropdown is hidden in the stylesheet.
      On desktop the theme's own Filter button does nothing, so this
      wires the open, close and Escape, and gives the drawer a title
      where the theme leaves it out. Styling is in
      brand-2026-tweaks-3.css and brand-2026-tweaks-4.css.
  10. Most loved arrows on phones (7 Oct, round one amends). Below
      768px the theme runs the homepage's Most loved row as a plain
      scroll row with nothing to say it scrolls, so a button is put
      either side of the row, each moving it one card (the card's
      width plus the gap). Homepage section 7V8fBM only. Styling in
      brand-2026-tweaks-6.css.
  11. USP row auto-advance on phones (16 Oct, Ben's Stage Two list).
      Below 768px the homepage's USP row (section icons_row_4nBUnf) is
      the theme's plain scroll row, so unlike the press band above it
      nothing moves. Every 2 seconds (the press band's duration
      setting, both taken from 3 to 2 on 16 Oct at Francesca's ask)
      the row scrolls one item along, through each item's start and
      the row's end, then back to the start. It waits until the band
      is in view, pauses while the pointer is over it, while a finger
      is on it, while anything in it has focus and while the tab is
      hidden, stops for the visit once the visitor swipes the row
      sideways, presses an arrow key in it or trackpad-scrolls it
      sideways, and does nothing from 768px up. Like the theme's own
      press band it does not read prefers-reduced-motion. The row is
      the theme's scroll-snap row, and iPhone Safari ignores a smooth
      scrollTo inside a snap row, so the move is animated by hand
      with snapping off for the third of a second it takes, and lands
      on the item's exact snap point by a plain assignment at the end
      so the row moves even where the frames in between are refused
      (16 Oct, evening: Francesca's phone showed it still). A finger
      landing on the row to scroll the page no longer stops it, only
      a sideways swipe does. Third agreed exception to the no-scripts
      rule, after the running total and the reviews band.
   All of these watch for content the theme loads later (quick view,
   bag drawer, filters). */
(function () {
  var rules = [
    [/(\d)[\s\u00A0]+(g\/m(?:²|2)|gsm)/g, '$1$2'],
    [/(£\s?\d[\d,]*(?:\.\d{2})?)[\s\u00A0]+GBP\b/g, '$1'],
    [/(£\s?\d[\d,]*(?:\.\d{2})?)[\s\u00A0]*\/[\s\u00A0]*m\b/g, '$1/m']
  ];
  var weightRe = /(\d+(?:\.\d+)?g\/m(?:²|2))/;
  var titleSel = 'h1, h2, h3, .product-grid-item__title, .popup-quick-view__title, .product__title, [class*="__title"], [class*="-title"]';

  function needs(text) {
    for (var i = 0; i < rules.length; i++) {
      rules[i][0].lastIndex = 0;
      if (rules[i][0].test(text)) { rules[i][0].lastIndex = 0; return true; }
    }
    return false;
  }

  function apply(text) {
    for (var i = 0; i < rules.length; i++) {
      rules[i][0].lastIndex = 0;
      text = text.replace(rules[i][0], rules[i][1]);
    }
    return text;
  }

  function skip(p) {
    var tag = p.nodeName;
    return tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT' || tag === 'TITLE';
  }

  function tidy(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || skip(p)) return NodeFilter.FILTER_REJECT;
        if (needs(n.nodeValue)) return NodeFilter.FILTER_ACCEPT;
        if (weightRe.test(n.nodeValue) && !p.classList.contains('wl-weight') && p.closest(titleSel)) return NodeFilter.FILTER_ACCEPT;
        return NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      node.nodeValue = apply(node.nodeValue);
      var p = node.parentNode;
      if (!p || p.classList.contains('wl-weight') || !p.closest(titleSel)) continue;
      var m = weightRe.exec(node.nodeValue);
      if (!m) continue;
      var before = node.nodeValue.slice(0, m.index);
      var after = node.nodeValue.slice(m.index + m[0].length);
      var span = document.createElement('span');
      span.className = 'wl-weight';
      span.textContent = m[0];
      node.nodeValue = before;
      if (node.nextSibling) p.insertBefore(span, node.nextSibling); else p.appendChild(span);
      if (after) {
        var tail = document.createTextNode(after);
        if (span.nextSibling) p.insertBefore(tail, span.nextSibling); else p.appendChild(tail);
      }
    }
  }

  /* 4. cards: trim the name, move the weight to its own line, drop "From" */
  function fitCardTitles(root) {
    var scope = (root && root.nodeType === 1 ? root : document);
    var titles = scope.querySelectorAll('.product-grid-item__title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      if (!t.dataset.wlFull) t.dataset.wlFull = t.innerHTML;
      var full = t.dataset.wlFull;
      var plain = full.replace(/<[^>]+>/g, '');
      var wm = weightRe.exec(plain);
      var text = full
        .replace(/<span class="wl-weight">[^<]*<\/span>/ig, '')
        .replace(weightRe, '')
        .replace(/(^|[\s\u00A0>])washed[\s\u00A0]+/i, '$1')
        .replace(/(^|[\s\u00A0>])pure[\s\u00A0]+/i, '$1')
        .replace(/[\s\u00A0]+fabrics?\b/i, '')
        .replace(/[\s\u00A0]+$/, '')
        .replace(/^(\s*(?:<[^>]+>\s*)*)([a-z])/, function (m, tags, c) { return tags + c.toUpperCase(); });
      if (t.innerHTML !== text) t.innerHTML = text;
      var row = t.parentElement ? t.parentElement.querySelector('.product-grid-item__price-row') : null;
      if (row && wm && !row.querySelector('.wl-weight')) {
        var s = document.createElement('span');
        s.className = 'wl-weight wl-weight--row';
        s.textContent = wm[1];
        row.insertBefore(s, row.firstChild);
      }
    }
    var froms = scope.querySelectorAll('.product-grid-item .price__from');
    for (var j = 0; j < froms.length; j++) {
      var f = froms[j];
      if (/^\s*From\s+/i.test(f.textContent)) f.textContent = f.textContent.replace(/^\s*From\s+/i, '');
    }
  }

  /* 5. Fabric samples: the footer's chevron as real markup */
  var CHEVRON = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-select wl-samples-arrow" viewBox="0 0 192 192"><path d="m72 36 60 60-60 60" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  function samplesArrow() {
    var links = document.querySelectorAll('.site-header .menu__items--secondary .navlink--toplevel[href*="sample"]');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].querySelector('.wl-samples-arrow')) links[i].insertAdjacentHTML('beforeend', CHEVRON);
    }
  }

  /* 6. FAQ heading over two lines, second line italic */
  function faqHeading() {
    var heads = document.querySelectorAll('.accordions-section .section__heading');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.dataset.wlSplit === 'true') continue;
      var words = h.textContent.trim().split(/\s+/);
      if (words.length < 2) { h.dataset.wlSplit = 'true'; continue; }
      var last = words.pop();
      h.innerHTML = words.join(' ') + '<br><em>' + last + '</em>';
      h.dataset.wlSplit = 'true';
    }
  }

  /* 7. product page price: "per metre" becomes "/m", closed up */
  function perMetre(root) {
    var units = (root && root.nodeType === 1 ? root : document).querySelectorAll('.per-metre-text');
    for (var i = 0; i < units.length; i++) {
      var u = units[i];
      if (u.dataset.wlUnit === 'true') continue;
      u.textContent = '/m';
      u.dataset.wlUnit = 'true';
      var prev = u.previousSibling;
      while (prev && prev.nodeType === 3 && !prev.nodeValue.trim()) {
        var gone = prev;
        prev = prev.previousSibling;
        gone.parentNode.removeChild(gone);
      }
    }
  }

  /* 8. Judge.me: keep the first review badge, hide any others */
  function oneReviewBadge() {
    var badges = document.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
    for (var i = 1; i < badges.length; i++) {
      badges[i].style.display = 'none';
      badges[i].setAttribute('aria-hidden', 'true');
    }
  }

  /* 9. Filter & sort drawer */
  var FILTER_ICON = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="14" height="14"><path d="M1 3.5h14M3.5 8h9M6 12.5h4" stroke="currentColor" stroke-width="1" stroke-linecap="round" fill="none"/></svg>';
  function closeFilters() { document.body.classList.remove('wl-filters-open'); }
  function openFilters() { document.body.classList.add('wl-filters-open'); }
  function filtersDrawer() {
    var wrap = document.querySelector('[data-section-type="collection-template"]');
    if (!wrap) return;
    var panel = wrap.querySelector('collection-filters');
    if (!panel) return;
    var bar = wrap.querySelector('.collection__sort-bar');
    if (bar && !bar.querySelector('.wl-filter-toggle')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl-filter-toggle';
      b.setAttribute('aria-controls', 'CollectionFilters');
      b.innerHTML = 'Filter &amp; sort ' + FILTER_ICON;
      b.addEventListener('click', function () {
        if (document.body.classList.contains('wl-filters-open')) closeFilters(); else openFilters();
      });
      bar.appendChild(b);
    }
    var header = panel.querySelector('.collection__filters-header');
    if (header && !header.querySelector('.collection__filters__title')) {
      var t = document.createElement('div');
      t.className = 'collection__filters__top wl-filters-top';
      t.innerHTML = '<div class="collection__filters__title"><span>Filter &amp; sort</span></div>';
      header.appendChild(t);
    }
    var titleSpan = panel.querySelector('.collection__filters__title span');
    if (titleSpan && !/sort/i.test(titleSpan.textContent)) titleSpan.textContent = 'Filter & sort';
    var closes = panel.querySelectorAll('[data-close-filters]');
    for (var i = 0; i < closes.length; i++) {
      if (closes[i].dataset.wlBound) continue;
      closes[i].dataset.wlBound = '1';
      closes[i].addEventListener('click', closeFilters);
    }
    if (!window.__wlFiltersEsc) {
      window.__wlFiltersEsc = true;
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });
    }
  }

  /* 10. Most loved: arrows on phones */
  function lovedArrows() {
    var sec = document.querySelector('[id$="__section_collection_7V8fBM"]');
    if (!sec) return;
    var box = sec.querySelector('.featured-collection__container');
    var row = sec.querySelector('.grid.carousel--mobile');
    if (!box || !row || box.querySelector('.wl-row-arrow')) return;
    function step() {
      var card = row.querySelector('.product-grid-item');
      if (!card) return row.clientWidth;
      var gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
      var margin = parseFloat(window.getComputedStyle(card).marginRight) || 0;
      return card.getBoundingClientRect().width + margin + gap;
    }
    function make(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl-row-arrow wl-row-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Previous products' : 'More products');
      b.innerHTML = dir < 0 ? '&lsaquo;' : '&rsaquo;';
      b.addEventListener('click', function () { row.scrollBy({ left: dir * step(), behavior: 'smooth' }); });
      box.appendChild(b);
    }
    make(-1);
    make(1);
  }

  /* 11. USP row: auto-advance on phones */
  function uspAutoAdvance() {
    var sec = document.querySelector('[id$="__section_icons_row_4nBUnf"]');
    if (!sec) return;
    var row = sec.querySelector('.icons-row__slider');
    if (!row || row.dataset.wlAuto === '1') return;
    row.dataset.wlAuto = '1';

    var HOLD = 2000, GLIDE = 320;
    var narrow = window.matchMedia('(max-width: 767px)');
    var inView = false, paused = false, touching = false, stopped = false, timer = null, gliding = false;

    function stops() {
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) return [];
      var pad = parseFloat(window.getComputedStyle(row).scrollPaddingLeft) || 0;
      var base = row.getBoundingClientRect().left;
      var list = row.querySelectorAll('.icons-row-item');
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var x = Math.round(list[i].getBoundingClientRect().left - base + row.scrollLeft - pad);
        if (x > max) x = max;
        if (x < 0) x = 0;
        if (!out.length || out[out.length - 1] !== x) out.push(x);
      }
      return out;
    }

    /* Snapping off, scrollLeft eased by hand, snapping back on once
       the row sits on the item's own snap point. */
    function glide(to) {
      var from = row.scrollLeft, dist = to - from;
      if (Math.abs(dist) < 1 || gliding) return;
      gliding = true;
      var snap = row.style.getPropertyValue('scroll-snap-type'), beh = row.style.getPropertyValue('scroll-behavior'), t0 = null;
      row.style.setProperty('scroll-snap-type', 'none', 'important');
      row.style.setProperty('scroll-behavior', 'auto', 'important');
      function done(landed) {
        if (landed) row.scrollLeft = to;
        row.style.removeProperty('scroll-snap-type');
        row.style.removeProperty('scroll-behavior');
        if (snap) row.style.setProperty('scroll-snap-type', snap);
        if (beh) row.style.setProperty('scroll-behavior', beh);
        if (landed && Math.abs(row.scrollLeft - to) > 2) row.scrollLeft = to;
        gliding = false;
      }
      function step(ts) {
        if (stopped || touching) return done(false);
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / GLIDE);
        row.scrollLeft = from + dist * (1 - Math.pow(1 - p, 3));
        if (p < 1) window.requestAnimationFrame(step); else done(true);
      }
      window.requestAnimationFrame(step);
    }

    function tick() {
      if (stopped) return halt();
      if (paused || touching || gliding || !inView || document.hidden || !narrow.matches) return;
      var pts = stops();
      if (!pts.length) return;
      var cur = row.scrollLeft, next = pts[0];
      for (var i = 0; i < pts.length; i++) { if (pts[i] > cur + 1) { next = pts[i]; break; } }
      glide(next);
    }

    function start() { if (!timer && !stopped) timer = setInterval(tick, HOLD); }
    function halt() { if (timer) { clearInterval(timer); timer = null; } }
    function stop() { stopped = true; halt(); }

    var tx = null, ty = null;
    row.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      touching = true;
      tx = t ? t.clientX : null; ty = t ? t.clientY : null;
    }, { passive: true });
    row.addEventListener('touchmove', function (e) {
      var t = e.touches && e.touches[0];
      if (!t || tx === null) return;
      var dx = Math.abs(t.clientX - tx), dy = Math.abs(t.clientY - ty);
      if (dx > 8 && dx > dy) stop();
    }, { passive: true });
    row.addEventListener('touchend', function () { touching = false; tx = ty = null; }, { passive: true });
    row.addEventListener('touchcancel', function () { touching = false; tx = ty = null; }, { passive: true });
    row.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') stop(); }, { passive: true });
    row.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    row.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') stop(); });
    sec.addEventListener('mouseenter', function () { paused = true; });
    sec.addEventListener('mouseleave', function () { paused = false; });
    sec.addEventListener('focusin', function () { paused = true; });
    sec.addEventListener('focusout', function () { paused = false; });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else halt();
      }, { threshold: 0.2 }).observe(sec);
    } else {
      inView = true;
      start();
    }
  }

  function run(root) {
    tidy(root || document.body);
    fitCardTitles(root);
    samplesArrow();
    faqHeading();
    perMetre(root);
    oneReviewBadge();
    filtersDrawer();
    lovedArrows();
    uspAutoAdvance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  if (window.MutationObserver) {
    var timer;
    var pending = [];
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData' && m.target.parentNode) { pending.push(m.target.parentNode); continue; }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) { if (!added[j].classList.contains('wl-weight') && !added[j].classList.contains('wl-samples-arrow') && !added[j].classList.contains('wl-filter-toggle') && !added[j].classList.contains('wl-filters-top') && !added[j].classList.contains('wl-row-arrow')) pending.push(added[j]); }
          else if (added[j].nodeType === 3 && added[j].parentNode) pending.push(added[j].parentNode);
        }
      }
      if (!pending.length) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var batch = pending; pending = [];
        for (var k = 0; k < batch.length; k++) {
          if (batch[k].closest && batch[k].closest('.product-grid-item__title')) continue;
          if (batch[k].closest && batch[k].closest('.product-grid-item__price-row')) continue;
          if (batch[k].closest && batch[k].closest('.section__heading')) continue;
          run(batch[k]);
        }
      }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
